<template>
  <div class="home">
    <!-- 外层容器：占满整个视口高度 -->
    <el-container class="full-height-container">
      <el-header class="top-box">
        <!-- 顶部导航内容不变 -->
        <el-row :gutter="24">
          <el-col :span="18">
            <img class="logo" src="../assets/logo.png" alt="兰州财经大学校徽">
            <span class="title-span">兰州财经大学MBA校友会小程序后台管理系统</span>
          </el-col>
          <el-col :span="6">
            <div class="info-box">
              <!-- 新增：用户头像 -->
              <img
                  class="user-avatar"
                  :src="userInfo.avatar || 'https://static-lzufe-lunbot-1258267596.cos.ap-guangzhou.myqcloud.com/avatars/%E7%AE%A1%E7%90%86%E5%91%98.png'"
                  alt="用户头像"
                  @error="handleAvatarError"
              >
              <span>{{ userInfo.name }}</span>
              <el-button type="danger" round @click="loginOutFun">退出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>

      <!-- 中间容器：包含左侧菜单和右侧内容，占满剩余高度 -->
      <el-container class="middle-container">
        <!-- 左侧菜单栏 -->
        <el-aside width="200px" class="aside-menu">
          <el-menu
              :router="true"
              class="el-menu-vertical-demo"
          >
            <el-menu-item :route="i.path" v-for="i in tabList" :key="i.name" :index="i.name">
              <template #title>{{ i.meta.title }}</template>
            </el-menu-item>
          </el-menu>
        </el-aside>

        <!-- 右侧内容区：占满剩余宽度和高度 -->
        <el-main class="content-area">
          <div class="content-box">
            <router-view/>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import router from "../router/index";
import {ElMessage} from "element-plus";
import {loginOut} from '@/http/api'

export default {
  name: "HomeView",
  setup() {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {};
    const token = sessionStorage.getItem('token');
    let tabList = router.options.routes[1].children;

    // 处理头像加载失败
    const handleAvatarError = (e) => {
      e.target.src = '../assets/default-avatar.png';
    }

    let loginOutFun = () => {
      loginOut({ token }).then(res => {
        if (res.code === 200) {
          router.push('/')
        } else {
          ElMessage.error(res.msg || '退出失败')
        }
      }).catch(err => {
        console.log(err)
        ElMessage.error('网络错误，请重试')
      })
    }

    return {tabList, userInfo, loginOutFun, handleAvatarError};
  },
};
</script>

<style lang="scss" scoped>
// 基础样式：清除默认边距
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

// 根容器占满高度
.home {
  height: 100%;
}

// 外层容器：占满整个视口高度
::v-deep .full-height-container {
  height: 100vh; // 视口高度，与浏览器窗口一致
  display: flex;
  flex-direction: column; // 垂直排列（header在上，中间容器在下）
}

// 顶部导航：固定高度，不参与剩余高度分配
.top-box {
  background: #efefef;
  padding: 5px;
  height: 65px; // 固定高度
  flex: none; // 不伸缩，固定高度
  border-bottom: 1px solid #e6e6e6;

  .logo {
    width: 50px;
    vertical-align: middle;
  }

  .title-span {
    color: #bd0638;
    font-size: 25px;
    padding-left: 10px;
    display: inline-flex;
    align-items: center;
    height: 50px;
  }

  .info-box {
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    gap: 12px; // 元素之间的间距
  }

  // 新增：用户头像样式
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%; // 圆形头像
    object-fit: cover; // 保持图片比例，填充整个容器
    border: 2px solid #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }

  .out-btn {
    margin-left: 10px;
  }
}

// 中间容器：包含左侧和右侧，占满剩余高度
.middle-container {
  flex: 1; // 占据外层容器剩余高度（100vh - 60px）
  display: flex;
  height: 100%; // 继承父容器高度
}

// 左侧菜单：占满中间容器高度
.aside-menu {
  height: 100%; // 与中间容器等高
  background-color: #f5f7fa;
  border-right: 1px solid #e6e6e6;

  .el-menu-vertical-demo {
    height: 100%; // 菜单占满左侧容器
    border-right: none;
  }
}

// 右侧内容区：占满中间容器剩余宽度和高度
.content-area {
  padding: 20px;
  height: 100%; // 与中间容器等高
  overflow: hidden; // 隐藏溢出，由内部content-box处理滚动
}

// 右侧内容容器：占满右侧区域，内容超出时滚动
.content-box {
  padding: 20px;
  background: #fff;
  height: 100%; // 占满右侧内容区高度
  overflow-y: auto; // 内容超出时显示垂直滚动条
  box-sizing: border-box; // 避免padding导致高度溢出
}
</style>
